// 导出核心类型
export * from '@podesigner/core'

// 导出编辑器类
export * from './editor/BaseEditor'

// 导出设计器组件
export { default as PoDesigner } from './components/PoDesigner.vue'

// SDK版本
export const VERSION = '1.0.0'

// 创建编辑器的便捷函数
export { BaseEditor as CuzcuzEditor } from './editor/BaseEditor'

// Vue插件安装函数
import type { App } from 'vue'
import PoDesigner from './components/PoDesigner.vue'

export const install = (app: App) => {
  app.component('PoDesigner', PoDesigner)
}

// 默认导出（用于全局安装）
export default {
  install,
  PoDesigner,
  VERSION
} 